// extracted by mini-css-extract-plugin
export default {"HomePage":"HomePage_HomePage__PDWlC","title":"HomePage_title__qrM5R"};